export const env = {
  isTesting: !!process.env.REACT_APP_IS_TESTING,
};
